import React from 'react';
import { Link } from 'react-router-dom';

const UpdateAccountSettingLink = () => (
  <Link to="/user-account/settings">Update your account settings</Link>
);

export default UpdateAccountSettingLink;


// WEBPACK FOOTER //
// ./src/components/common/update-account-setting-link.js